import React, { useState } from "react";
import GetInTouch from "../../components/GetInTouch.js";
import VoipSolContact from "../../components/VoipSolContact.js";

const pointsData = [
  {
    title: "Replace Physical Presence",
    content:
      "We all lose potential clients when we can't reach the meeting location or primarily when we can't have a physical meeting. Audio-video conferencing solutions act as an escape in such a scenario where you can conduct meetings from any geographic location and be as effective as in person. This means the sky is the limit, and you can quickly grab lucrative opportunities in different locations.",
  },
  {
    title: "Efficient Communication",
    content:
      "With conferencing solutions, communication becomes much more efficient. It allows you to connect with your team or clients at any time without the need to be physically present.",
  },
  {
    title: "Ensure Participants Presence",
    content:
      "Conferencing solutions help ensure that all participants are present and engaged during the meeting by providing tools like attendance tracking, screen sharing, and real-time interaction.",
  },
  {
    title: "Consolidated Communication",
    content:
      "The use of conferencing solutions consolidates all forms of communication, allowing for seamless meetings without worrying about connectivity or location.",
  },
];

const AudioVideoConfSolution = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className=" flex flex-col items-center justify-center p-6 mb-6">
      <div className="flex flex-col md:flex-row justify-between items-center    mb-4">
        <div className="md:w-2/3 space-y-6 p-4">
          <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Transform Your Workforce with Advanced Conferencing Solutions
          </h1>
          <p className="text-gray-700 text-base lg:text-xl">
            Ensure effortless connectivity and robust security for seamless team
            collaboration. In today's world, staying connected with remote
            employees and clients is essential. Our video conferencing solution
            provides a secure communication channel, enhanced with the
            flexibility of third-party integrations.
          </p>
          <p className="text-gray-700 text-base lg:text-xl">
            Harness the power of our cutting-edge collaborative tools to
            revolutionize the way your team interacts and tackles challenges.
            With our tailored multi-tenant audio and video conferencing
            solutions, foster smooth communication with remote teams and
            clients, taking your business operations to new heights.
          </p>
        </div>

        <VoipSolContact />
      </div>

      <div className=" text-center rounded-2xl ">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-5 mt-10">
          Essential Features of Our Conferencing Solutions
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold  max-w-6xl mx-auto">
          Enhance team collaboration with a range of advanced features tailored
          to support your workforce.
        </p>

        <div className="p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Conference Recording</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Set Conference Duration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Mute/Unmute Participants</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Rollcall and Hangup Features</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Organize and Record Conversations</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Customizable Music on Hold</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Entry-Exit Chimes</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Conference-Wise Polling</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Conference Scheduler</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Active Speaker Display</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Volume Balance Controls</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Set Number of Participants</p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Brew Audio-Video Conferencing Solutions
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto mb-4">
          Foster efficient team communication and collaboration in real-time,
          ensuring you stay ahead in a competitive environment.
        </p>
      </div>

      <div className="">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/2 ">
            <img
              src="/assets/images/headerSection/audioVideo.jpg"
              alt="Audio & Video Conferencing Solutions Provider in India"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Streamline communication to deliver results on time, from
                  anywhere, while ensuring privacy and reducing costs.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Enjoy enhanced mobility and flexibility to boost productivity
                  across your teams.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Strengthen connections among your workforce, fostering
                  collaboration regardless of physical distance.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Share resources effortlessly through screen sharing and direct
                  file transfer capabilities.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Simplify management and improve usability with a customizable
                  interface that can be centrally controlled.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Access a comprehensive suite of features including chat, video
                  conferencing, and live streaming all in one place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="text-center mb-10 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Audio & Video Conferencing Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
            A multi-tenant conferencing solution is crucial for enabling
            multiple users to connect and benefit from a single platform. Today,
            audio-video conferencing is essential in industries like Education,
            Healthcare, IT, Telecom, and more, enabling wider reach and boosting
            revenue generation. Multi-tenant conferencing software offers a
            range of advantages.
          </p>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-7xl mx-auto mb-20">
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="text-lg">
              A global workforce that functions across different regions and
              locations.
            </p>
          </div>

          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="text-lg">
              Bridging the gap between remotely located teams, enabling
              round-the-clock meetings and service delivery.
            </p>
          </div>

          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="text-lg">
              A user-friendly, multi-tenant web conferencing platform with apps
              that track employee performance via reports and dashboards.
            </p>
          </div>

          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="text-lg">
              Save significant time and reduce infrastructure costs by
              eliminating the need for travel, while boosting business
              productivity.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-green-50 p-4 mb-12 sm:mb-16 rounded-3xl">
        {/* Title Section */}
        <h2 className="text-center  sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6">
          Tailored Conferencing Solution
        </h2>
        <p className="text-center text-base sm:text-lg md:text-xl text-gray-700 mb-8">
          Audio video conferencing solutions are beneficial when physical
          presence is impossible. We at Ayanshtech have developed custom-built
          multi-tenant web conferencing software that has proven to be a sturdy
          companion in rough weather. There are several pain points that are
          combated using conferencing solution.
        </p>

        {/* Navigation Bar */}
        <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4">
          {pointsData.map((point, index) => (
            <button
              key={index}
              className={`text-base sm:text-lg font-medium ${
                activeIndex === index
                  ? "text-blue-600 underline"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveIndex(index)}
            >
              {point.title}
            </button>
          ))}
        </div>

        {/* Content Section */}
        <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
            {pointsData[activeIndex].content}
          </p>
        </div>
      </div>

      <div className="text-center mb-16  p-4">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Why Choose Ayanshtech as Your Partner for Conferencing Solution
          Development
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
          The demand for multi-tenant conferencing software has surged in
          response to evolving market needs. With the rise of remote work,
          especially post-pandemic, it is crucial to address this growth
          effectively. To meet these increasing demands, a close partnership
          with the right solution provider is key. Multi-tenant web conferencing
          systems ensure that distance is never a barrier, allowing seamless
          communication between teams and clients at all times.
        </p>
      </div>

      <GetInTouch />
    </div>
  );
};

export default AudioVideoConfSolution;
